// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.E33GxroAiAunlNc2FAHn{position:relative}.aTAYCVGZsFUe3GXYNYJf{align-items:center;display:flex}.pjQB7wJl98GbfAScW6LD{color:var(--content-primary-tertiary);margin-right:10px}.F1Cy4wEqc8uPsLnJ_L2u{align-items:center;display:flex}.nMUbekGu6IUNA4FbuQlY{color:var(--content-neutral-primary)}.TVPQSMsZtYwddKg8QlwK{color:var(--content-primary-primary);text-overflow:ellipsis;max-width:130px;overflow:hidden}.gl7uNtteu_c4xl4ZY7oH{color:var(--content-neutral-primary);margin:0 8px}._La6y8nJIcH9RFNLevKA{color:var(--content-primary-tertiary);gap:4px;display:flex}.ehA5HGd2eSkZtZoLPPQH{padding:2px}.f7EekzvAOAwDseqsQ6Ea{padding:10px}.WkCaLzKb1nYdkBg7JCT7{align-items:center;gap:4px;display:flex}.SUa8a5vt5eUH3cxsYftV{color:var(--gray-60);justify-content:center;padding:8.5px 0;font-size:12px;font-weight:400;line-height:15px;display:flex}.gxTGnSoPUof_GB1ykLSE{align-items:center;padding:4px 8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `E33GxroAiAunlNc2FAHn`,
	"trigger": `aTAYCVGZsFUe3GXYNYJf`,
	"trigger__icon": `pjQB7wJl98GbfAScW6LD`,
	"triggerIcon": `pjQB7wJl98GbfAScW6LD`,
	"trigger__label": `F1Cy4wEqc8uPsLnJ_L2u`,
	"triggerLabel": `F1Cy4wEqc8uPsLnJ_L2u`,
	"trigger__label--placeholder": `nMUbekGu6IUNA4FbuQlY`,
	"triggerLabelPlaceholder": `nMUbekGu6IUNA4FbuQlY`,
	"trigger__name": `TVPQSMsZtYwddKg8QlwK`,
	"triggerName": `TVPQSMsZtYwddKg8QlwK`,
	"trigger__dot": `gl7uNtteu_c4xl4ZY7oH`,
	"triggerDot": `gl7uNtteu_c4xl4ZY7oH`,
	"trigger__number": `_La6y8nJIcH9RFNLevKA`,
	"triggerNumber": `_La6y8nJIcH9RFNLevKA`,
	"loaderTrigger": `ehA5HGd2eSkZtZoLPPQH`,
	"loader": `f7EekzvAOAwDseqsQ6Ea`,
	"scaleLabel": `WkCaLzKb1nYdkBg7JCT7`,
	"noResult": `SUa8a5vt5eUH3cxsYftV`,
	"multiSelectPlaceholder": `gxTGnSoPUof_GB1ykLSE`
};
export default ___CSS_LOADER_EXPORT___;
